import { defineComponent as a, useModel as n, createBlock as r, openBlock as e, Transition as d, withCtx as s, createElementBlock as m, createCommentVNode as u, renderSlot as c } from "vue";
const i = {
  key: 0,
  class: "ui-overlay"
}, f = /* @__PURE__ */ a({
  __name: "UiOverlay",
  props: {
    modelValue: { type: Boolean },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(o) {
    const t = n(o, "modelValue");
    return (l, p) => (e(), r(d, { name: "fade" }, {
      default: s(() => [
        t.value ? (e(), m("div", i, [
          c(l.$slots, "default")
        ])) : u("", !0)
      ]),
      _: 3
    }));
  }
});
export {
  f as _
};
